'use strict';

module.exports = {
	configurationAttributeName: 'measurements-config',
	measurementAttributeName: 'measurements'
};
